const STORAGE_KEY = 'dismissedFeatureAnnouncementCards';

const cardContainer = document.querySelector('.feature-announcement-card');

if (cardContainer && window.CookieConsent?.validConsent()) {
    const cardId = cardContainer.dataset.cardId;

    const ctaButton = cardContainer.querySelector('.feature-announcement-card__cta-button');
    const declineButton = cardContainer.querySelector('.feature-announcement-card__decline-button');
    const closeButton = cardContainer.querySelector('.feature-announcement-card__close');
    const avatarLink = document.querySelector('.feature-announcement-card-avatar');

    const dismissedCards = localStorage.getItem(STORAGE_KEY)
        ? localStorage.getItem(STORAGE_KEY).split(',')
        : [];

    const displayCard = () => {
        if (dismissedCards.includes(cardId)) {
            cardContainer.hidden = true;
            if (avatarLink) {
                avatarLink.hidden = false;
            }
            return;
        }

        cardContainer.hidden = false;
        if (avatarLink) {
            avatarLink.hidden = true;
        }
    };

    const closeCard = () => {
        dismissedCards.push(cardId);
        localStorage.setItem(STORAGE_KEY, dismissedCards.join(','));

        setTimeout(() => {
            cardContainer.classList.add('feature-announcement-card--closing');

            cardContainer.addEventListener(
                'animationend',
                () => {
                    cardContainer.hidden = true;

                    if (avatarLink) {
                        avatarLink.hidden = false;
                        avatarLink.focus();
                    }
                },
                { once: true },
            );
        });
    };

    displayCard();

    declineButton.addEventListener('click', () => {
        closeCard();
    });

    closeButton.addEventListener('click', () => {
        closeCard();
    });

    ctaButton.addEventListener('click', () => {
        closeCard();
    });
}
